import { render, staticRenderFns } from "./InventoryTransferList.vue?vue&type=template&id=f68581c2&"
import script from "./InventoryTransferList.vue?vue&type=script&lang=js&"
export * from "./InventoryTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports